<app-launch-field-container [basespaceFormControl]="formControl">
    <rad-select 
    class="rad-theme--light" 
    [attr.multiple]="formControl.multiselect"
    [formControl]="formControl"
    >
        <rad-option 
        *ngFor="let choice of formControl.choices"
        [attr.value]="choice.value"
        [attr.label]="choice.text"
        ></rad-option>
    </rad-select>
</app-launch-field-container>